import { Component, ElementRef, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { environment } from 'src/environments/environment';
import { FilterService } from '../../services/filter.service';
import { GeocodingAddressService } from '../../services/geocoding-address.service';

@Component({
    selector: 'app-address-mapview',
    templateUrl: './address-mapview.component.html',
    styleUrls: ['./address-mapview.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddressMapviewComponent implements OnInit {

	@ViewChild('map') contentMap: ElementRef;

	@Input() locations: any[] = [];
	@Input() activePin: boolean = false;
	@Input() timeout: number = 0; //delay to search
	@Input() searchText: string = '';
	@Input() locationAddress: any = null;
	@Input() activeLocationAddres: boolean = false;
	@Input() searchByLocationAddress: boolean = false;

	@Output() onUpdateLocs = new EventEmitter<any[]>();
	@Output() onUpdateLatLng = new EventEmitter<{ lat: number, lng: number }>();

	map: google.maps.Map;
	markers: google.maps.Marker[] = [];
	dragEventListMap: google.maps.MapsEventListener;
	optionAddressList = [];
	timeoutAddress: any = null;
	addressOptions: any[] = [];
	mainMarker: google.maps.Marker;

	constructor(
		private _geocoding: GeocodingAddressService,
		private _fS: FilterService,
	) { }

	ngAfterViewInit(): void {
		this.createAddressMap();
		if (this.activePin) this.activePinDraggable();
	}

	ngOnInit(): void {
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes['locations'] && this.locations.length && this.map) {
			this.createAddressMap();
		}
		if (changes['searchText']) this.onChangeAddress();
	}

	createAddressMap() {
		let currentCenter = { lat: 0, lng: 0 };
		let currentZoom = 3;

		if (this.locations.length) {
			currentZoom = 15;
			currentCenter = { lat: this.locations[0].lat, lng: this.locations[0].lng };
		}
		if (this.activeLocationAddres && this.locationAddress?.lat && this.locationAddress?.lng) {
			currentZoom = 15;
			currentCenter = { lat: this.locationAddress.lat, lng: this.locationAddress.lng };
		}

		this.map = new google.maps.Map(this.contentMap.nativeElement as HTMLElement, {
			center: currentCenter,
			zoom: currentZoom,
			streetViewControl: false,
			zoomControl: false,
			mapTypeControl: false,
			fullscreenControl: false
		})

		this.createMarkersMap();
		if (this.locations.length > 1) this.centerMap();
	}

	centerMap() {
		const lat_min = Math.min(...this.locations.map(x => x.lat))
		const lng_min = Math.min(...this.locations.map(x => x.lng))
		const lat_max = Math.max(...this.locations.map(x => x.lat))
		const lng_max = Math.max(...this.locations.map(x => x.lng))

		this.map.setCenter({ lat: (lat_max + lat_min) / 2.0, lng: (lng_max + lng_min) / 2.0 })
		const bounds = new google.maps.LatLngBounds(
			new google.maps.LatLng(lat_min, lng_min),
			new google.maps.LatLng(lat_max, lng_max)
		)
		this.map.fitBounds(bounds)

	}

	createMarkersMap() {
		this.locations.forEach(address => {
			const myLatLng = { lat: address.lat, lng: address.lng };

			const marker = new google.maps.Marker({
				position: myLatLng,
				map: this.map,
				title: address.address,
			});

			this.markers.push(marker);
		});
	}

	activePinDraggable() {
		this.markers.forEach(market => {
			market.setMap(null);
		})

		this.markers = [];

		this.mainMarker = new google.maps.Marker({
			position: this.map.getCenter(),
			map: this.map,
		});

		this.dragEventListMap = google.maps.event.addListener(this.map, 'drag', async event => {
			this.mainMarker.setPosition(this.map.getCenter());

			if (this.timeoutAddress) {
				clearTimeout(this.timeoutAddress);
				this.timeoutAddress = null;
			}
		});

		this.dragEventListMap = google.maps.event.addListener(this.map, 'click', async event => {
			this.mainMarker.setPosition(event?.latLng);
			const response = await this._geocoding.reverseGeoCodingAddress(event?.latLng.lat(), event?.latLng.lng());

			this.setAddressList(response);
		});

		this.dragEventListMap = google.maps.event.addListener(this.map, 'dragend', async event => {
			const center = this.map.getCenter();
			const response = await this._geocoding.reverseGeoCodingAddress(center.lat(), center.lng());

			this.setAddressList(response);
			this.onUpdateLatLng.emit({ lat: center.lat(), lng: center.lng()})
		});
	}

	// generateStaticMap() {
	// 	const center = this.map.getCenter()
	// 	const markers = this.locations.map(x => `${x.lat},${x.lng}`).join('%7C')

	// 	const params = {
	// 		key: environment.mapsKey,
	// 		center: `${center.lat()},${center.lng()}`,
	// 		zoom: this.locations.length > 1 ? `${this.map.getZoom()}` : '15',
	// 		size: '1024x768',
	// 		markers: `color:0x4fc3f7%7C${markers}`
	// 	}

	// 	const parseParams = Object.keys(params).map(key => `${key}=${params[key]}`).join('&')
	// 	return `${environment.staticMap}?${parseParams}`
	// }

	public centerMarker(location) {
		this.map.setCenter({ lat: location.lat, lng: location.lng })
		this.map.setZoom(15);
	}

	public exportMap() {
		// const staticMap = this.generateStaticMap()
		return null
	}

	setAddressList(geocodeList, createMarker: boolean = false) {
		this.optionAddressList = geocodeList.map(address => {
			const city = this.getAddressComponente(address, 'administrative_area_level_2') || this.getAddressComponente(address, 'locality') || this.getAddressComponente(address, 'administrative_area_level_1');
			const components = [
				this.getAddressComponente(address, 'administrative_area_level_2'),
				this.getAddressComponente(address, 'administrative_area_level_1'),
				this.getAddressComponente(address, 'postal_code') != '' ? `(${this.getAddressComponente(address, 'postal_code')})` : ''
			].filter(x => x != '').join(', ')

			return {
				route: this.getAddressComponente(address, 'route'),
				address: address.formatted_address,
				country: this.getAddressComponente(address, 'country'),
				state: this.getAddressComponente(address, 'administrative_area_level_1'),
				city,
				postal_code: this.getAddressComponente(address, 'postal_code'),
				lat: address.geometry.location.lat(),
				lng: address.geometry.location.lng(),
				components
			}
		});

		if (this.optionAddressList.length && this.map) {
			let position = { lat: this.optionAddressList[0].lat, lng: this.optionAddressList[0].lng };
			if (this.activeLocationAddres && this.locationAddress?.lat && this.locationAddress?.lng) {
				position = { lat: this.locationAddress.lat, lng: this.locationAddress.lng };
			}

			this.map.setCenter(position);

			if (createMarker) {
				this.createMarker(position);
				this.onUpdateLatLng.emit(position);
			}
		}


		this.locations = this.optionAddressList;
		this.onUpdateLocs.emit(this.optionAddressList);
	}

	getAddressComponente(address, addresType) {
		const component = address.address_components.find(component => component.types.includes(addresType))
		return component ? component.long_name : ''
	}

	async onChangeAddress() {
		clearTimeout(this.timeoutAddress);

		this.timeoutAddress = setTimeout(async () => {
			let normalizeAddress = this._fS.normalizeString(this.searchText);
			const geocoding = await this.getGeocodingData(normalizeAddress);

			if (geocoding && geocoding.length > 0) {
				this.addressOptions = geocoding;
			} else {
				this.addressOptions = [];
			}

			if (!this.addressOptions.length && this.searchByLocationAddress && this.locationAddress?.lat && this.locationAddress?.lng) {
				this.setlocationAddress();
			} else {
				this.setAddressList(this.addressOptions, true);
			}

		}, this.timeout);
	}

	createMarker(position: { lat: number, lng: number }) {
		if (this.mainMarker) {
			this.mainMarker.setMap(this.map);
			this.mainMarker.setPosition(position);
		} else {
			this.mainMarker = new google.maps.Marker({
				position: position,
				map: this.map,
			});
		}
		this.map.setZoom(15)
	}

	public setMarkerPosition(position: { lat: number, lng: number }) {
		this.mainMarker.setPosition(position);
		this.centerMarker(position);
	}

	async setlocationAddress() {
		const response = await this._geocoding.reverseGeoCodingAddress(this.locationAddress.lat, this.locationAddress.lng);
		this.createMarker({ lat: this.locationAddress.lat, lng: this.locationAddress.lng });
		this.setAddressList(response, true);
	}

	async getGeocodingData(address: string) {
		try {
			const geocoding = await this._geocoding.geoCodingAddress(address);
			return geocoding;
		} catch {
			return null;
		}
	}
}
